var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152 40",
    width: 152,
    height: 40,
    role: "img",
    "aria-label": "SolicitorQs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#2c5696"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.2V18.6M8.4 18.6H15.6M5.2 7.6H18.8M5.2 7.6L3.4 13M5.2 7.6L7 13M18.8 7.6L17 13M18.8 7.6L20.6 13"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1.25,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9 13H7.5A2.3 2.3 0 0 1 2.9 13Z M16.5 13H21.1A2.3 2.3 0 0 1 16.5 13Z",
    fill: "#ffffff"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 28,
    fontFamily: "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#23395b",
    letterSpacing: -0.66
  }, "Solicitor", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 800,
    fill: "#1e304d"
  }, "Qs"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17e5c697770454615bf6588e21011952.svg";
export { ForwardRef as ReactComponent };